import React from 'react';

import { CreateUser } from 'presentation/pages';

export const MakeCreateUserFactory: React.FC = () => {
  return <CreateUser />;
};
